import React from 'react';
import MessageItem from './message-item';

const ChatMessages = ({ messages, isLoading, formatMessageToHtml, toggleDropdown, dropdownOpen, handleCopy, handleEdit }) => {
  return (
    <div className="card-body msg_card_body chat-scroll">
      {isLoading && (
        <div className="typing-indicator">
          <img
            src="https://img.freepik.com/free-vector/3d-ai-robot-character-chat-bot-wink-mascot-icon_107791-30020.jpg"
            alt="User"
            className="typing-avatar"
          />
          <div className="typing-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      )}
      {messages.length === 0 && !isLoading && (
        <p className="text-center">Tôi có thể giúp gì cho bạn?</p>
      )}
      <ul className="list-unstyled">
        {messages.map((message) => (
          <MessageItem
            key={message.id}
            message={message}
            formatMessageToHtml={formatMessageToHtml}
            toggleDropdown={toggleDropdown}
            dropdownOpen={dropdownOpen}
            handleCopy={handleCopy}
            handleEdit={handleEdit}
          />
        ))}
      </ul>
    </div>
  );
};

export default ChatMessages;